/**
 * Exploit Cell Renderer
 *
 * Renders the public exploits availability indicator.
 * Displays Yes/No/- based on whether public exploits exist for the vulnerability.
 */

import React from 'react';

import type { RiskWithVulnerability } from '@/hooks/useRisks';

interface ExploitCellProps {
  risk: RiskWithVulnerability;
}

/**
 * Memoized cell renderer for public exploits column
 *
 * Displays whether public exploits are available for this vulnerability.
 * Shows "Yes" if exploits exist, "No" if none exist, or "-" if unknown.
 *
 * @param risk - The vulnerability/risk to check for exploits
 * @returns Text indicator of exploit availability
 */
export const ExploitCell: React.FC<ExploitCellProps> = React.memo(
  ({ risk }) => {
    const displayText =
      risk.exploit === undefined ? '-' : risk.exploit ? 'Yes' : 'No';

    return <span className="text-chariot-text-primary">{displayText}</span>;
  }
);

ExploitCell.displayName = 'ExploitCell';
